import AnimatedSection from "./AnimatedSection";

function Footer() {
  return (
    <footer className="w-full py-16 border-t border-slate-200/50 bg-slate-50">
      <AnimatedSection>
        <div className="flex flex-col md:flex-row justify-between items-center px-12 max-w-7xl mx-auto space-y-8 md:space-y-0 font-body text-sm">
          <div className="flex flex-col items-center md:items-start gap-4">
            <span className="text-xl font-black text-slate-900">SOLID</span>
            <p className="text-slate-500 text-center md:text-left">
              &copy; 2026 SOLID. The Pristine Exchange.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-8">
            <a className="text-slate-500 hover:text-cyan-500 transition-colors duration-200" href="/privacy">
              Privacy Policy
            </a>
            <a className="text-slate-500 hover:text-cyan-500 transition-colors duration-200" href="/terms">
              Terms of Service
            </a>
            <a className="text-slate-500 hover:text-cyan-500 transition-colors duration-200" href="mailto:team@solidfavours.com">
              Contact Us
            </a>
          </div>

          <div className="flex gap-6">
            <a
              className="text-slate-500 hover:text-cyan-500 transition-colors duration-200"
              href="https://instagram.com/solidfavours"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </div>
        </div>
      </AnimatedSection>
    </footer>
  );
}

export default Footer;
